AppTabs.createTab( {
name: 'dnr-test-management',
icon: 'vial',
text: 'DNR Test Management',
create: function(init) {
	'use strict'

	init.setDataTableArgs( {

		tableId: 		'#data-table-dnr-test-management',

		readTableName: 	'tblDNR',
		editTableName: 	'tblDNR',
		primaryKey: 	'DNRID',

		hasColumnFilters: 	true,
		canSearch: 			true,
		canSort:			true,

		actionData:			'datatable',
		actionCreate:		'datatable_create',
		actionEdit:			'datatable_edit',
		actionRemove:		'datatable_remove',

		editCallback:		function() {
			window.broadcastLocalStorageUpdateRequest( 'dnrTestList' );
		},

		fields: [
			{
				label: 		'Test',
				columnName: 'TestID',
				isEditable: true,
				type:		'test',
				render: 	DataTablesManager.getTestNameByID,
				sort:		'asc',
			},
			{
				label: 'DNR Test Name',
				columnName: 'DNRName',
				isEditable: true,
				sort:		'asc',
			},
			{
				label: 'Dissolved Or Total',
				columnName: 'DNRDissolvedOrTotal',
				isEditable: true,
				type: 'select',
				options: [
					{ label: 'Dissolved', value: 'D' },
					{ label: 'Total',     value: 'T' },
				],
				searchOptions: [
					{ label: 'Dissolved', value: 'D' },
					{ label: 'Total',     value: 'T' },
				],
			},
			{
				label: 'Number',
				columnName: 'DNRNum',
				isEditable: true,
				type: 'number',
			},
			{
				label: 'Method',
				columnName: 'DNRMethod',
				isEditable: true,
			},
			{
				label: 'Units',
				columnName: 'DNRUnits',
				type: 'combobox',
				datalist: 'units',
				isEditable: true,
			},
			{
				label: 'PAL',
				columnName: 'DNRPAL',
				isEditable: true,
			},
			{
				label: 'ES',
				columnName: 'DNRES',
				isEditable: true,
			},
			{
				label: 'DNR Alt. Name',
				columnName: 'DNRTestName',
				isEditable: true,
			},
		],

	} );
}

} );
